/**
 * Get the protocol (http or https) based on current location
 */
const getProtocol = (): string => {
  return window.location.protocol;
};

/**
 * Construct subdomain URL based on current domain
 * @param subdomain - The subdomain to prepend (e.g., 'static', 'api')
 * @returns Full URL with subdomain
 */
const getSubdomainUrl = (subdomain: string): string => {
  const hostname = window.location.hostname;
  const protocol = getProtocol();
  const port = window.location.port;

  // For localhost, use environment variables or construct subdomain URLs
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Check if env vars are set for local development
    if (subdomain === 'static' && import.meta.env.VITE_STATIC_URL) {
      return import.meta.env.VITE_STATIC_URL;
    }
    if (subdomain === 'api' && import.meta.env.VITE_API_URL) {
      return import.meta.env.VITE_API_URL;
    }
    // Default: construct subdomain URLs for localhost
    // Modern browsers support .localhost TLD natively (routes to 127.0.0.1)
    const portSuffix = port ? `:${port}` : '';

    // Use subdomain.localhost:port format for consistency with production
    return `${protocol}//${subdomain}.localhost${portSuffix}`;
  }

  // For production domains, construct subdomain
  // If domain is already a subdomain (e.g., www.alexmachekhin.dev), extract base domain
  const parts = hostname.split('.');
  let baseDomain: string;

  if (parts.length >= 2) {
    // Extract the last two parts (domain.tld)
    baseDomain = parts.slice(-2).join('.');
  } else {
    baseDomain = hostname;
  }

  return `${protocol}//${subdomain}.${baseDomain}`;
};

export const config = {
  apiUrl: getSubdomainUrl('api'),
  staticUrl: getSubdomainUrl('static'),
};
